/** Copyright (c) 2025 DAIA Tech Pvt Ltd. All rights reserved.
 *
 * This software is confidential and proprietary information of DAIA Tech Pvt Ltd
 * and its licensors. You shall not disclose such Confidential Information and shall
 * use it only in accordance with the terms of the license agreement.
 *
 * Unauthorized reproduction, modification, distribution, or disclosure of this
 * software is strictly prohibited.
 */

import type { ComponentRendererConfig } from '../shared/Types';
import { UserText } from './components/UserText';
import { UserAudio } from './components/UserAudio';
import { UserVideo } from './components/UserVideo';
import { UserImage } from './components/UserImage';
import { UserMCQ } from './components/UserMCQ';
import { UserPRPTextComparison } from './components/UserPRPTextComparison';

/**
 * Configuration mapping user component dtypes to their Chakra UI components
 */
export const UserComponentRendererConfig: ComponentRendererConfig = {
  TEXT: UserText,
  AUDIO: UserAudio,
  VIDEO: UserVideo,
  IMAGE: UserImage,
  MCQ: UserMCQ,
  PRP_TEXT_COMPARISON: UserPRPTextComparison,
};
